/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisibilityEnum } from './visibilityEnum';
import { SeverityEnum } from './severityEnum';


export interface AgentJobUpdateDetailsSpec { 
    args?: Array<string>;
    /**
     * Error code
     */
    code?: string;
    /**
     * Error message
     */
    message?: string;
    /**
     * Message id
     */
    message_id?: string;
    severity?: SeverityEnum;
    visibility?: VisibilityEnum;
}
export namespace AgentJobUpdateDetailsSpec {
}


